module.exports = __webpack_public_path__ + "img/zhsjwkzz98.26e4e7d8.png";